import { render, staticRenderFns } from "./tradesperson-sidebar.vue?vue&type=template&id=33300dba&scoped=true"
import script from "./tradesperson-sidebar.vue?vue&type=script&lang=js"
export * from "./tradesperson-sidebar.vue?vue&type=script&lang=js"
import style0 from "./tradesperson-sidebar.vue?vue&type=style&index=0&id=33300dba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33300dba",
  null
  
)

export default component.exports